import React from 'react';

// Tinted placeholder card for products without a real photo.
// Renders inside the standard cw-img-wrap aspect 4:5.
export const PlaceholderImage = ({
  label,
  bg = '#EFE7DC',
  ink = '#3A2A14',
  subLabel = 'Photo coming soon',
}) => {
  return (
    <div
      className="w-full h-full flex flex-col items-center justify-center text-center px-4"
      style={{ backgroundColor: bg, color: ink }}
    >
      {/* Soft soap-bar silhouette */}
      <svg
        viewBox="0 0 80 80"
        className="w-12 h-12 mb-4 opacity-80"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="14" y="26" width="52" height="32" rx="6" />
        <path d="M14 38 Q40 30 66 38" opacity="0.5" />
        <circle cx="40" cy="20" r="2" opacity="0.6" />
        <circle cx="30" cy="14" r="1.4" opacity="0.6" />
        <circle cx="50" cy="14" r="1.4" opacity="0.6" />
      </svg>

      <div className="font-heading text-2xl font-medium leading-tight" style={{ color: ink }}>
        {label}
      </div>
      <div
        className="mt-3 text-[10px] uppercase tracking-[0.22em] font-semibold opacity-70"
        style={{ color: ink }}
      >
        {subLabel}
      </div>
    </div>
  );
};
